<script lang="ts">
  import type {Poem} from '../types'
  import {t} from '../i18n'
  import {Tooltip} from '@svelte-plugins/tooltips'
  import {user} from '../stores/user'

  export let poem: Poem
</script>

<div class="grid__card" class:pending={poem.status === 'pending_check'}>
  {#if poem.status === 'pending_check'}
    <Tooltip content={t.poem.pending_check} action="hover">
      <div class="clock" />
    </Tooltip>
  {/if}

  <div class="grid__short-wrap">
    <h4>
      <div>
        <a href={`/poems/${poem.handle}`}>{poem.title}</a>
        {#if poem.status === 'draft'}
          <span class="draft">{t.poem.draft}</span>
        {/if}
      </div>

      {#if poem.user_id === $user?.id}
        <a class="edit" href={`/poems/${poem.handle}/edit`}>
          {t.poem.edit}
        </a>
      {/if}
    </h4>
    {#if poem.preview_image}
      <a class="grid__img" href={`/poems/${poem.handle}`}>
        <img src={poem.preview_image} alt={poem.title}/>
      </a>
    {/if}
    <p class="grid__short">{@html poem.preview}</p>
  </div>

  {#if poem.read_more}
    <a class="italic continue" href={`/poems/${poem.handle}`}>{t.poem.continue_reading}</a>
  {/if}

  <div class="soc-actions">
    <div class="soc-item views">
      <i class="icon-p icon-p-eye"></i>
      <span>{poem.views_count}</span>
    </div>
    <div class="soc-item likes">
      <i class="icon-p icon-p-like"></i>
      <span>{poem.likes_count}</span>
    </div>
    <div class="soc-item comments">
      <i class="icon-p icon-p-comment"></i>
      <span>{poem.comments_count}</span>
    </div>
  </div>

  <hr/>

  <div class="post-author italic">
    <span>{t.poem.by}</span>
    {#each poem.authors as author, index}
      <a href={author.link}>{author.full_name}</a>
      {#if index < poem.authors.length - 1}
        ,&nbsp;
      {/if}
    {/each}
  </div>
</div>
